module.exports = __webpack_public_path__ + "img/logo.25c7e8ef.png";